document.addEventListener('DOMContentLoaded', () => {
    
    // Aguarda o jQuery e o Form
    const waitForJQuery = setInterval(() => {
        if (window.jQuery && window.jQuery('.variations_form').length) {
            clearInterval(waitForJQuery);
            initSwatches(window.jQuery);
        }
    }, 100);

    const initSwatches = ($) => {
        console.log('WPMundi: Iniciando Swatches...');

        const wrappers = document.querySelectorAll('.wpmundi-swatches-wrapper');

        wrappers.forEach(wrapper => {
            const parent = wrapper.parentElement;
            let select = parent ? parent.querySelector('select') : null;
            
            // Fallback de busca
            if (!select) {
                const attrName = wrapper.getAttribute('data-attribute-name');
                const form = wrapper.closest('form');
                if (form) select = form.querySelector(`select[name="${attrName}"]`);
            }

            if (!select) return;

            const $select = $(select);
            const $form   = $select.closest('.variations_form');

            // 1. Ocultar Select Nativo
            select.classList.add('wpmundi-hidden-select');


            // --- FUNÇÃO: Verificar Estoque ---
            /* const checkAvailability = () => {
                const swatches = wrapper.querySelectorAll('.wpmundi-swatch');
                swatches.forEach(swatch => {
                    const value = swatch.getAttribute('data-value');
                    // Verifica se a option existe no select (Woo remove as inválidas)
                    // Escape de aspas duplas para segurança
                    const optionExists = $select.find(`option[value="${value.replace(/"/g, '\\"')}"]`).length > 0;
                    
                    if (!optionExists) {
                        swatch.classList.add('wpmundi-unavailable');
                    } else {
                        swatch.classList.remove('wpmundi-unavailable');
                    }
                });
            }; */

            const checkAvailability = () => {
                // Captura o mapa de todas as variações injetadas pelo WooCommerce
                const variationsData = $form.data('product_variations');
                if (!variationsData) return;

                // Captura as seleções atuais de TODOS os selects do formulário
                const currentSelections = {};
                $form.find('select[name^="attribute_"]').each(function() {
                    const name = $(this).attr('name');
                    const val = $(this).val();
                    if (val) {
                        currentSelections[name] = val;
                    }
                });

                const currentAttrName = select.getAttribute('name');
                const swatches = wrapper.querySelectorAll('.wpmundi-swatch');

                swatches.forEach(swatch => {
                    const value = swatch.getAttribute('data-value');
                    
                    // 1. Checagem Básica: O WooCommerce removeu a opção do <select>?
                    const optionExists = $select.find(`option[value="${value.replace(/"/g, '\\"')}"]`).length > 0;

                    if (!optionExists) {
                        swatch.classList.add('wpmundi-unavailable');
                        return; // Pula para o próximo swatch
                    }

                    // 2. Checagem Avançada: Lógica de Estoque
                    // Vamos simular: E se o usuário selecionasse ESTE swatch agora?
                    const testSelections = { ...currentSelections, [currentAttrName]: value };
                    
                    let isAvailable = false;
                    let hasMatch = false;

                    // Procura no mapa do WooCommerce se essa combinação existe e tem estoque
                    for (let i = 0; i < variationsData.length; i++) {
                        const variation = variationsData[i];
                        let match = true;

                        // Verifica se a variação bate com a nossa simulação
                        for (const attrKey in testSelections) {
                            const testValue = testSelections[attrKey];
                            const variationValue = variation.attributes[attrKey];

                            // Se a variação tem uma regra específica para esse atributo e ela não bate (e não é "Qualquer"='')
                            if (variationValue !== undefined && variationValue !== '' && variationValue !== testValue) {
                                match = false;
                                break;
                            }
                        }

                        if (match) {
                            hasMatch = true;
                            // Se achou a combinação, verifica se está em estoque E comprável
                            // O WooCommerce já considera "Permitir Encomendas" como is_in_stock = true
                            if (variation.is_in_stock && variation.is_purchasable) {
                                isAvailable = true;
                                break; // Já achou uma disponível, não precisa procurar mais
                            }
                        }
                    }

                    // Se a combinação existe no mapa, mas NENHUMA está em estoque: Bloqueia!
                    if (hasMatch && !isAvailable) {
                        swatch.classList.add('wpmundi-unavailable');
                    } else {
                        swatch.classList.remove('wpmundi-unavailable');
                    }
                });
            };

            // Listener do WooCommerce para recálculo de estoque
            $form.on('woocommerce_update_variation_values', () => checkAvailability());


            // 2. Listener: Mudança no Select (Visual + Label)
            $select.on('change', function() {
                const val = $(this).val();
                
                // A. Visual da Bolinha
                const swatches = wrapper.querySelectorAll('.wpmundi-swatch');
                swatches.forEach(s => {
                    if (s.getAttribute('data-value') === val) {
                        s.classList.add('selected');
                    } else {
                        s.classList.remove('selected');
                    }
                });

                // B. Texto do Label (ex: "Cor: Amarelo")
                const labelSelector = `label[for="${select.id}"]`;
                const $label = $form.find(labelSelector);

                if ($label.length) {
                    let $valueSpan = $label.find('.wpmundi-selected-value');
                    if ($valueSpan.length === 0) {
                        $valueSpan = $('<span class="wpmundi-selected-value"></span>');
                        $label.append($valueSpan);
                    }

                    if (val) {
                        const selectedText = $select.find(`option[value="${val.replace(/"/g, '\\"')}"]`).text();
                        $valueSpan.text(': ' + selectedText);
                    } else {
                        $valueSpan.text('');
                    }
                }
            });


            // 3. Listener: Clique no Swatch
            const swatches = wrapper.querySelectorAll('.wpmundi-swatch');
            swatches.forEach(swatch => {
                swatch.addEventListener('click', function(e) {
                    e.preventDefault();

                    if (this.classList.contains('wpmundi-unavailable')) return; 

                    const value = this.getAttribute('data-value');

                    // Seleção visual imediata
                    swatches.forEach(s => s.classList.remove('selected'));
                    this.classList.add('selected');

                    // Atualiza dados
                    $select.val(value);
                    $select.trigger('change');
                    $form.trigger('check_variations');
                });
            });


            // --- 4. INICIALIZAÇÃO INTELIGENTE (O SEGREDO) ---
            // Verifica se o PHP já selecionou uma opção (porque veio da URL com parâmetro)
            const initialValue = $select.val();
            
            if ( initialValue && initialValue !== '' ) {
                console.log('WPMundi: Detectado valor vindo da URL:', initialValue);
                
                // 1. Força o visual a atualizar imediatamente (pinta a bolinha e põe o texto)
                $select.trigger('change');

                // 2. LIMPEZA DA URL (SEM RECARREGAR)
                // Se a URL contém parâmetros de atributo, nós a limpamos visualmente agora.
                // O usuário vê o produto selecionado, mas a URL fica limpa.
                if ( window.history.replaceState && window.location.search.indexOf('attribute_') > -1 ) {
                     const cleanUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                     window.history.replaceState({path: cleanUrl}, '', cleanUrl);
                     console.log('WPMundi: URL limpa visualmente.');
                }
            }


            // 5. CORREÇÃO DE ROLAGEM (Clean Code)
            if ( ! $form.hasClass('wpmundi-reset-fixed') ) {
                $form.addClass('wpmundi-reset-fixed');
                
                const resetBtn = $form.get(0).querySelector('.reset_variations');
                if (resetBtn) {
                    resetBtn.addEventListener('click', function(e) {
                        e.preventDefault(); // Evita pular
                        $form.find('.wpmundi-selected-value').text(''); // Limpa texto
                    }, true); // Fase de Captura
                }
            }
        });
    };
});